import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { DownloadIcon, BookOpenIcon, MessageCircleIcon } from 'lucide-react';
export function HowItWorksSection() {
  const steps = [{
    icon: <DownloadIcon className="w-6 h-6 text-primary" data-id="element-154" />,
    title: 'Descargás',
    desc: 'Descargás el Pack de forma inmediata tras la compra.'
  }, {
    icon: <BookOpenIcon className="w-6 h-6 text-primary" data-id="element-155" />,
    title: 'Consultás',
    desc: 'Consultás los ejercicios y checklists antes de cada clase.'
  }, {
    icon: <MessageCircleIcon className="w-6 h-6 text-primary" data-id="element-156" />,
    title: 'Respondés',
    desc: 'Respondés con seguridad cada vez que te pregunten "por qué".'
  }];
  return <section className="py-6 bg-background border-y border-card-border relative overflow-hidden" data-id="element-157">
      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-158">
        <FadeIn className="text-center mb-6" data-id="element-159">
          <h2 className="text-2xl md:text-3xl font-black mb-2 text-gray-900" data-id="element-160">
            ¿Cómo{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-secondary" data-id="element-161">
              Funciona
            </span>
            ?
          </h2>
          <p className="text-base text-gray-500" data-id="element-162">
            Tres pasos simples para transformar tu seguridad profesional.
          </p>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-4 relative" data-id="element-163">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-8 left-1/6 right-1/6 h-0.5 bg-gradient-to-r from-transparent via-primary/30 to-transparent -z-10" data-id="element-164" />

          {steps.map((step, index) => <FadeIn key={index} delay={0.1 + index * 0.1} direction="up" data-id="element-165">
              <div className="flex flex-col items-center text-center group" data-id="element-166">
                <div className="w-16 h-16 rounded-full bg-white border-2 border-primary/30 flex items-center justify-center mb-4 shadow-[0_0_20px_rgba(245,158,11,0.1)] group-hover:border-primary group-hover:shadow-[0_0_30px_rgba(245,158,11,0.3)] transition-all duration-500 relative" data-id="element-167">
                  <div className="absolute inset-1.5 rounded-full bg-card flex items-center justify-center" data-id="element-168">
                    {step.icon}
                  </div>
                  <div className="absolute -top-1.5 -right-1.5 w-6 h-6 rounded-full bg-primary text-white font-bold flex items-center justify-center text-xs shadow-lg" data-id="element-169">
                    {index + 1}
                  </div>
                </div>
                <h3 className="text-lg font-bold mb-1 text-gray-900" data-id="element-170">
                  {step.title}
                </h3>
                <p className="text-gray-500 text-sm leading-relaxed" data-id="element-171">
                  {step.desc}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}